<template>
  <div class="container-fluid card card-content p-3">
    <!-- <div class="text-center">
      <h3 class="titulo">ALTA DE SERVIDOR PÚBLICO</h3>
    </div> -->
    <legend>Verificar el estado del servidor público ( RFC ):</legend>
    <div class="col-sm-6 col-md-6 col-lg-6">
      <!-- <label>Verificar el estado del servidor público ( RFC ):</label> -->
      <input class="form-control text-uppercase" type="text" v-model="filter" placeholder="Buscar">
      <small class="text-danger" v-if="busqueda">La búsqueda requiere un mínimo de 10 letras</small>
    </div>
    <div class="coloremp" v-if="txtemp" v-html="txtemp">
    </div>

    <div class="row mt-3" v-if="Object.keys(uTemp).length !== 0">
      <div class="col-12">
        {{uTemp.nombres}} {{uTemp.primer_apellido}} {{uTemp.segundo_apellido}}, {{uTemp.rfc}}
      </div>
      <div class="col-12 font-weight-bolder">
        {{uTemp.fecha_termino?'Usuario con baja':'Usuario activo'}} en {{uTemp.ente}}
      </div>
      <div class="col-12 text-danger" v-if="!uTemp.fecha_termino">
        <v-alert color="orange" class="mt-3 p-2">
          El servidor público actualmente se encuentra Activo. Verifique esta información con el usuario ya que debe solicitar la baja antes de crear el alta del usuario.
        </v-alert>
      </div>

      <div class="col-12 mb-3" v-if="uTemp.fecha_termino !=null">
        <button class="btn btn-success" @click.prevent="copyData()">
          <span>
            <i class="far fa-copy"></i> Copiar datos del usuario
          </span>
        </button>
      </div>
    </div>


    <div v-if="pendientes">
      <legend>Información general del Servidor Público</legend>
      <div class="row">
        <div class="col-md-4 form-group">
          <label class="control-label">
            Nombre(s)
          </label>
          <input class="form-control" type="text" name="nombres" v-validate="modelValidations.nombres" v-model="model.nombres" placeholder="Nombre(s)" />
          <small class="text-danger" v-show="nombres.invalid">
            {{ getError('nombres') }}
          </small>
        </div>
        <div class="col-md-4 form-group">
          <label class="control-label">
            Apellido Paterno
          </label>
          <input class="form-control" type="text" name="primer_apellido" v-validate="modelValidations.primer_apellido" v-model="model.primer_apellido" placeholder="Apellido Paterno" />
          <small class="text-danger" v-show="primer_apellido.invalid">
            {{ getError('primer_apellido') }}
          </small>
        </div>
        <div class="col-md-4 form-group">
          <label class="control-label">
            Apellido Materno
          </label>
          <input class="form-control" type="text" name="segundo_apellido" v-model="model.segundo_apellido" placeholder="Apellido Materno" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 form-group">
          <label class="control-label">
            CURP
          </label>
          <input class="form-control" type="text" name="curp" v-validate="modelValidations.curp" v-model="model.curp" placeholder="CURP" />
          <small class="text-danger" v-show="curp.invalid">
            {{ getError('curp') }}
          </small>
          <small class="text-danger" v-show="validaciones.curp">
            El formato de la CURP no es válido, verifica la información
          </small>
        </div>
        <div class="col-md-4 form-group">
          <label class="control-label">
            RFC:
          </label>
          <input class="form-control" type="text" name="rfc" v-validate="modelValidations.rfc" v-model="model.rfc" placeholder="RFC" />
          <small class="text-danger" v-show="rfc.invalid">
            {{ getError('rfc') }}
          </small>
          <small class="text-danger" v-show="validaciones.rfc">
            El formato del RFC no es válido, verifica la información
          </small>
        </div>

        <div class="col-md-4 form-group">
          <label class="control-label">
            Fecha de Nacimiento
          </label>
          <div class="form-group m-0">
            <el-date-picker name="fecha_nacimiento" v-validate="modelValidations.fecha_nacimiento" v-model="model.fecha_nacimiento" format="dd/MM/yyyy" type="date" placeholder="Elige un día">
            </el-date-picker>
          </div>
          <small class="text-danger" v-show="fecha_nacimiento.invalid">
            {{ getError('fecha_nacimiento') }}
          </small>
        </div>
      </div>
      <legend>Datos de la declaracion</legend>
      <div class="row">
        <div class="col-md-4 form-group">
          <label class="control-label">
            Tipo de declaración
          </label>
          <el-select clearable class="select-default" filterable name="simplificada" v-validate="'required'" placeholder="Tipo de declaración" v-model="model.simplificada">
            <el-option v-for="option in tipos" class="select-default" :value="option.id" :label="option.valor" :key="option.id">
            </el-option>
          </el-select>
          <small class="text-danger">
            {{ getError('simplificada') }}
          </small>
        </div>
        <div class="col-md-4 form-group" v-if="Object.keys(uTemp).length === 0">
          <label class="control-label">
            Declaración a realizar
          </label>
          <el-select clearable class="select-default" filterable name="tipo_dec" placeholder="Tipo declaración" v-model="model.tipo_dec">
            <el-option v-for="option in tipo_declaracion" class="select-default" :value="option.id" :label="option.valor" :key="option.id+'tipo'">
            </el-option>
          </el-select>
          <small class="text-danger">
            {{ getError('tipo_dec') }}
          </small>
        </div>
        <div class="col-md-4 form-group" v-if="Object.keys(uTemp).length === 0">
          <label class="control-label">
            Periodo
          </label>
          <el-select clearable class="select-default" filterable name="periodo" placeholder="Periodo" v-model="model.periodo">
            <el-option v-for="option in periodos" class="select-default" :value="option.year" :label="option.year" :key="option.year">
            </el-option>
          </el-select>
          <small class="text-danger">
            {{ getError('periodo') }}
          </small>
        </div>
        <!-- <div class="col-md-12 pt-0">
          <small class="text-danger">
            El declaración a realizar y periodo, solo aplica para usuarios nuevos.
          </small>
        </div> -->
      </div>

      <legend>Datos del encargo actual del Servidor Público.</legend>
      <div class="row" v-if="getKey('permisos').includes(17)">
        <div class="col-md-6 form-group">
          <label class="control-label">
            Ente público
          </label><br>
          <el-select clearable class="select-default" filterable name="ente" v-validate="modelValidations.ente" placeholder="Ente" v-model="model.ente_publico_id">
            <el-option v-for="option in entes" class="select-default" :value="option.id" :label="option.valor" :key="option.valor">
            </el-option>
          </el-select>
          <small class="text-danger" v-show="ente.invalid">
            {{ getError('ente') }}
          </small>
        </div>
      </div>
      <div class="row">

        <div class="col-md-8 form-group">
          <label class="control-label">
            Nombre del Empleo, Cargo o Comisión
          </label>
          <br>
          <input class="form-control" type="text" name="nombre_cargo" v-validate="modelValidations.nombre_cargo" v-model="model.empleo_cargo_comision" placeholder="Nombre del Cargo" />
          <small class="text-danger" v-show="nombre_cargo.invalid">
            {{ getError('nombre_cargo') }}
          </small>
        </div>
        <div class="col-md-4 form-group">
          <label class="control-label">
            Contrato por honorarios.
          </label><br>
          <p-radio name="honorarios" v-validate="modelValidations.honorarios" v-model="model.contratado_honorarios" label="1">SI</p-radio>
          <p-radio name="honorarios" v-validate="modelValidations.honorarios" v-model="model.contratado_honorarios" label="2">NO</p-radio>
          <small class="text-danger" v-show="honorarios.invalid">
            {{ getError('honorarios') }}
          </small>
        </div>
      </div>

      <div class="row">
        <div class="col-md-8 form-group">
          <label class="control-label">
            Área
          </label>
          <br>
          <input class="form-control" type="text" name="area" v-validate="modelValidations.area" v-model="model.area_adscripcion" placeholder="Area de adscripción" />
          <small class="text-danger" v-show="area.invalid">
            {{ getError('area') }}
          </small>
        </div>
        <div class="col-md-4 form-group">
          <label class="control-label">
            Fecha de toma de Posesión
          </label>
          <br>
          <el-date-picker name="toma_posesion" value-format="dd-MM-yyyy" format="dd-MM-yyyy" v-validate="modelValidations.toma_posesion" v-model="model.fecha_posesion" :picker-options="opciones" type="date" placeholder="Selecciona">
          </el-date-picker>
          <small class="text-danger" v-show="toma_posesion.invalid">
            {{ getError('toma_posesion') }}
          </small>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 form-group">
          <label class="control-label">
            Nivel
          </label>
          <input class="form-control" type="text" name="nivel" v-validate="modelValidations.nivel" v-model="model.nivel_encargo" placeholder="Nivel" />
          <small class="text-danger" v-show="nivel.invalid">
            {{ getError('nivel') }}
          </small>
        </div>
        <div class="col-md-6 form-group">
          <label class="control-label">
            Teléfono Laboral
          </label>
          <input class="form-control" type="text" name="curp" v-model="model.telefono_laboral_numero" placeholder="Teléfono Laboral" />
        </div>
        <div class="col-md-2 form-group">
          <label class="control-label">
            Ext
          </label>
          <input class="form-control" type="text" name="curp" v-model="model.telefono_laboral_extension" placeholder="Teléfono Laboral" />
        </div>
      </div>

      <br><br>
      <div class="row">

        <div class="col-md-4 form-group" v-if="mostrarCampos">
          <label class="control-label">
            Correo Electrónico Laboral
          </label>
          <input class="form-control" type="text" name="correo_laboral" v-validate="modelValidations.correo_laboral" v-model="model.correo_laboral" placeholder="Correo Laboral" />
          <small class="text-danger" v-show="correo_laboral.invalid">
            {{ getError('correo_laboral') }}
          </small>
        </div>
        <div class="col-md-6 form-group">
          <label class="control-label">
            RFC Patron:
          </label>
          <input class="form-control" type="text" name="rfc_patron" v-validate="modelValidations.rfc_patron" v-model="model.rfc_patron" placeholder="RFC del Patron" />
          <small class="text-danger" v-show="rfc.invalid">
            {{ getError('rfc_patron') }}
          </small>
          <small class="text-danger" v-show="validaciones.rfc_patron">
            El formato del RFC no es válido, verifica la información
          </small>
        </div>
        <div class="col-md-6 form-group">
          <label class="control-label">
            Correo Electrónico Laboral
          </label>
          <input class="form-control" type="text" name="correo_laboral" v-validate="modelValidations.correo_laboral" v-model="model.correo_laboral" placeholder="Correo Laboral" />
          <small class="text-danger" v-show="correo_laboral.invalid">
            {{ getError('correo_laboral') }}
          </small>
        </div>
      </div>
      <br>
      <domicilio v-model="n_domicilio" ref="Domicilio" titulo="/Ubicación del Cargo"></domicilio>
      <br>
      <div class="row">
        <div class="col-md-12 text-center">
          <button @click="guardar" class="btn btn-info btn-wd pull-right">
            <span class="btn-label">
              <i class="fa fa-save"></i>
            </span>
            GUARDAR
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    Tag,
    Select,
    DatePicker
  } from 'element-ui'
  import {
    mapFields
  } from 'vee-validate'
  import Domicilio from "./Formularios/Domicilio.vue";

  import swal from 'sweetalert2';

  export default {
    components: {
      [Tag.name]: Tag,
      [DatePicker.name]: DatePicker,
      Domicilio
    },
    inject: ['$validator'],

    data() {
      return {
        txtemp: '',
        coloremp: '',
        filter: '',
        uTemp: {},
        periodos: [],
        pendientes: false,
        mostrarCampos: false,
        transferencia: {},
        validaciones: {
          curp: false,
          rfc: false,
          rfc_patron: false
        },
        datePicker: '',
        ip_id: null,
        /* paises:{}, */
        regexp: {
          mail: ''
        },
        n_domicilio: {
          pais_id: 150, // México
          entidadF: 11, // Estado Guanajuato
          municipio: '',
          localidad: '',
          cp: '',
          colonia: '',
          vialidad: '',
          vialidad_nombre: '',
          ext: '',
          int: ''
        },
        model: {
          area_adscripcion: '',
          contratado_honorarios: '2',
          correo_laboral: '',
          curp: '',
          direccion_encargo_colonia: '',
          direccion_encargo_cp: '',
          direccion_encargo_entidad_federativa_id: '',
          direccion_encargo_localidad_id: '',
          direccion_encargo_municipio_id: '',
          direccion_encargo_numext: '',
          direccion_encargo_numint: '',
          direccion_encargo_pais_id: 150,
          direccion_vialidad_nombre: '',
          direccion_vialidad_tipo: '',
          empleo_cargo_comision: '',
          ente_publico_id: '',
          fecha_nacimiento: '',
          fecha_posesion: '',
          simplificada: '',
          nivel_encargo: '',
          nombres: '',
          primer_apellido: '',
          rfc: '',
          rfc_patron: '',
          periodo: null,
          tipo_dec: 1,
          segundo_apellido: '',
          telefono_laboral_extension: '',
          telefono_laboral_numero: ''
        },
        opciones: {
          disabledDate(date) {
            return date > new Date();
          }
        },
        mostrarCampos: false,
        ip_id: null,
        datePicker: "",
        edit_item: null,
        add_item: false,
        entidadFed: null,
        municipios: null,
        localidades: null,
        localidad: null,
        /*  paises: null, */
        entes: {},
        ambitos: {},
        funciones_p: {},
        tipos: [{
          'id': 1,
          'valor': 'Simplificada',
        }, {
          'id': 0,
          'valor': 'Completa',
        }, ],
        tipo_declaracion: [{
          'id': 1,
          'valor': 'Inicial',
        }, {
          'id': 2,
          'valor': 'Anual',
        }, {
          'id': 3,
          'valor': 'Final'
        }],

        sectores: {},
        // model: {
        //   fecha_posesion: '',
        //   contratado_honorarios: "2",

        // },
        modelValidations: {

          tipo: {
            required: true
          },
          correo_laboral: {
            email: true
          },
          ente: {
            required: true
          },
          nombre_cargo: {
            required: true
          },
          nivel: {
            required: true
          },
          honorarios: {
            required: true
          },
          nivel_orden: {
            required: true
          },
          area: {
            required: true
          },
          toma_posesion: {
            required: true
          },
          nombres: {
            required: true,
          },
          primer_apellido: {
            required: true,
          },
          curp: {
            required: true,
            max: 18
          },
          rfc: {
            required: true,
            max: 13
          },
          rfc_patron: {
            max: 13
          },
          fecha_nacimiento: {
            required: true
          },
          correo_electronico_laboral: {
            email: true
          }
          //falta el domicilio
        }
      }
    },
    computed: {
      ...mapFields(['nombres', 'primer_apellido', 'rfc', 'curp', 'fecha_nacimiento', 'correo_electronico_laboral',
        "correo_laboral", "ente", "nombre_cargo", "nivel", "honorarios", "area", "toma_posesion", "unidadadm", 'rfc_patron', 'tipo', 'tipo_dec', 'periodo'
      ]),
      busqueda() {
        if (this.filter.length >= 1 && this.filter.length < 10) {
          return true
        } else {
          return false;
        }
      }
    },
    watch: {
      n_domicilio: {
        handler: function () {

          if (this.n_domicilio) {
            this.model.direccion_encargo_pais_id = this.n_domicilio.pais ? this.n_domicilio.pais : 150;
            this.model.direccion_encargo_entidad_federativa_id = this.n_domicilio.entidadF ? this.n_domicilio.entidadF : "";
            this.model.direccion_encargo_municipio_id = this.n_domicilio.municipio ? this.n_domicilio.municipio : "";
            this.model.direccion_encargo_localidad_id = this.n_domicilio.localidad ? this.n_domicilio.localidad : "";
            this.model.direccion_encargo_cp = this.n_domicilio.cp ? this.n_domicilio.cp : "";
            this.model.direccion_vialidad_nombre = this.n_domicilio.vialidad_nombre ? this.n_domicilio.vialidad_nombre : "";
            this.model.direccion_vialidad_tipo = this.n_domicilio.vialidad ? this.n_domicilio.vialidad : "";
            this.model.direccion_encargo_numext = this.n_domicilio.ext ? this.n_domicilio.ext : "";
            this.model.direccion_encargo_numint = this.n_domicilio.int ? this.n_domicilio.int : "";
            this.model.direccion_encargo_colonia = this.n_domicilio.colonia ? this.n_domicilio.colonia : "";
            this.model.domicilio_observaciones = this.n_domicilio.domicilio_observaciones ? this.n_domicilio.domicilio_observaciones : "";

          }
        },
        deep: true
      },


      filter(val) {
        this.coloremp = 'info'
        this.uTemp = {};
        this.pendientes = false;
        if (val && val.length >= 10) {
          this.txtemp = 'Buscando...';
          this.uTemp = {};
          this.$http.get("infpersonal/altas/" + val).then(
            response => {

              if (response.data.usuarios.length == 0) {
                this.coloremp = 'danger';
                this.txtemp = 'No encontrado';
                this.pendientes = true;
                this.$validator.resume();
              } else {
                this.txtemp = ''; //response.data.usuarios;
                this.uTemp = response.data.usuarios;

                if (this.uTemp.fecha_termino != null) {
                  this.pendientes = true;
                  this.$validator.resume();
                } else {
                  this.pendientes = false;
                }
              }
            },
            error => {
              this.Err(error);
            }
          );
        } else {
          this.txtemp = 'Buscando...';
          this.pendientes = false;
        }
      },

      '$route': 'checkPermissions',
    },
    methods: {
      getPeriodos() {
        var v = this;
        this.$http.get("getPeriodos").then(
          response => {
            var anios = response.data.periodos;

            anios.forEach(y => {
              if (y.year) {
                this.periodos.push(y);
              }
            });
            this.model.periodo = this.periodos[0].year;
          },
          error => {
            this.StepError(error);
          }
        );
      },
      copyData() {
        this.$nextTick(() => {
          //  this.model = this.uTemp;
          this.model.nombres = this.uTemp.nombres;
          this.model.primer_apellido = this.uTemp.primer_apellido;
          this.model.segundo_apellido = this.uTemp.segundo_apellido;
          this.model.curp = this.uTemp.curp;
          this.model.rfc = this.uTemp.rfc;
          this.model.fecha_nacimiento = this.uTemp.fecha_nacimiento;
          this.model.simplificada = this.uTemp.simplificada;
          this.model.tipo_dec = 1;
          this.model.periodo = this.periodos[0].year;
        });
      },
      checkPermissions() {
        let permiso = [3];
        if (!this.getKey('permisos').some(r => permiso.includes(r))) {
          localStorage.clear();
          this.$router.push('/login');
          this.$router.go();

        }
      },
      isTrue(currentValue) {
        return currentValue;
      },
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll();
      },
      showItem() {
        this.add_item = !this.add_item;
      },
      getPais(index) {
        var resp = "México";
        if (this.paises) {
          this.paises.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      getEnte(index) {
        var resp = " ";
        if (this.entes) {
          this.entes.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor;
              return resp;
            }
          });
        }
        return resp;
      },
      cancelEdit() {
        if (this.edit_item) {
          this.edit_item.item._rowVariant = "";
        }
        this.limpiaCampos();
        this.showItem();
        this.edit_item = null;
      },
      getEntes() {
        var v = this;
        this.$http.get("cat_ente_publico").then(
          response => {
            this.entes = response.data.entes_publicos;
          },
          error => {
            this.StepError(error);
            console.log(error);
          }
        );
      },
      getSafe(fn, defaultVal) {
        try {
          return fn();
        } catch (e) {
          return defaultVal;
        }
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        var v = this;
        this.validaciones = {
          curp: false,
          rfc: false,
          rfc_patron: false
        }

        var validacurp = new Promise(function (resolve, reject) {
          if (!v.curpValida(v.getSafe(() => v.model.curp, ''))) {
            v.validaciones.curp = true;
            return reject(false)
          } else {
            return resolve(true)
          }
        });
        var validarfc = new Promise(function (resolve, reject) {
          if (!v.rfcValido(v.getSafe(() => v.model.rfc, ''))) {
            v.validaciones.rfc = true;
            return reject(false)
          } else {
            return resolve(true)
          }
        });
        var validarfcp = new Promise(function (resolve, reject) {
          // if (!v.rfcValido(v.getSafe(() => v.model.rfc_patron, ''))) {
          //   v.validaciones.rfc_patron = true;
          //   return reject(false)
          // } else {
          return resolve(true)
          //}
        });
        var dpersonales = this.$validator.validateAll()

        return Promise.all([dpersonales, validacurp, validarfc, validarfcp])
      },
      getSafe(fn, defaultVal) {
        try {
          return fn();
        } catch (e) {
          return defaultVal;
        }
      },
      guardar() {
        if (!(this.getKey('permisos').includes(17))) {
          this.model.ente_publico_id = this.getKey('ente_publico_id')
        }

        var v = this;
        this.validate().then( //funcion de datos personales que valida tdo
          response => {
            ///se verifica que todas las promesas sean verdaderas
            if (response.every(this.isTrue)) {
              this.$http.post("infpersonal", this.model).then(
                response => {
                  //console.log(response.data.mensaje)
                  if (response.data.mensaje.id != 'Ok') {
                    if (response.data.baja == "si") {
                      swal({
                        title: 'El RFC fué dado de baja con ésta información',
                        showCancelButton: true,
                        confirmButtonClass: 'btn btn-success btn-fill',
                        cancelButtonClass: 'btn btn-danger btn-fill',
                        confirmButtonText: 'SI',
                        cancelButtonText: 'NO',
                        html: '<b>RFC: </b>' + response.data.mensaje.rfc + '<br>' +
                          '<b>CURP: </b>' + response.data.mensaje.curp + '<br>' +
                          '<b>Dependencia:</b>' + response.data.mensaje.encargo.ente.valor + '<br>' +
                          '<b>Cargo: </b>' + response.data.mensaje.encargo.empleo_cargo_comision + '<br>' +
                          '¿Deseas crear el alta con los nuevos datos?',
                        buttonsStyling: false
                      }).then(function () {

                        v.transferencia.ip_id = response.data.mensaje.id;
                        v.transferencia.ente_publico_origen = response.data.mensaje.encargo.ente_publico_id;
                        v.transferencia.ente_publico_destino = v.model.ente_publico_id;
                        v.transferencia.datos_cambio = v.model;
                        // v.transferencia.periodo = v.periodo;
                        // v.transferencia.tipo_dec = v.tipo_dec;

                        v.transferencia.datos_actuales = {
                          rfc: response.data.mensaje.rfc,
                          nombres: response.data.mensaje.nombres,
                          primer_apellido: response.data.mensaje.primer_apellido,
                          segundo_apellido: response.data.mensaje.segundo_apellido,
                          curp: response.data.mensaje.curp,
                          area_adscripcion: response.data.mensaje.encargo.area_adscripcion,
                          contratado_honorarios: response.data.mensaje.encargo.contratado_honorarios,
                          correo_laboral: response.data.mensaje.encargo.correo_laboral,
                          empleo_cargo_comision: response.data.mensaje.encargo.empleo_cargo_comision,
                          ente_publico_id: response.data.mensaje.encargo.ente_publico_id,
                          fecha_nacimiento: response.data.mensaje.fecha_nacimiento,
                          fecha_posesion: response.data.mensaje.encargo.fecha_posesion,
                          simplificada: response.data.mensaje.encargo.simplificada,
                          nivel_encargo: response.data.mensaje.encargo.nivel_encargo,
                          fecha_termino: response.data.mensaje.encargo.fecha_termino

                        }

                        v.$http.post("reabaja", v.transferencia).then(
                          response => {
                            swal({
                              title: 'Alta',
                              text: 'Alta exitosa',
                              type: 'success',
                              confirmButtonClass: 'btn btn-success btn-fill',
                              buttonsStyling: false
                            })

                            v.limpiaCampos();


                          },
                          error => {
                            v.Err(error);
                          }
                        );


                      }).catch(e => {
                        console.log("catch")
                      })
                    } else {
                      this.StepW("Ya existe un registro con ese RFC o CURP en ésta dependencia")
                      // if (response.data.mensaje.ente_publico_id != this.model.ente_publico_id) {
                      // swal({
                      //   title: 'El RFC ya se encuentra dado de alta en otra dependencia',
                      //   showCancelButton: true,
                      //   confirmButtonClass: 'btn btn-success btn-fill',
                      //   // cancelButtonClass: 'btn btn-danger btn-fill',
                      //   confirmButtonText: 'cerrar',
                      //   // cancelButtonText: 'NO',
                      //   html: '<b>RFC: </b>' + response.data.mensaje.rfc + '<br>' +
                      //     '<b>CURP: </b>' + response.data.mensaje.curp + '<br>' +
                      //     '<b>Dependencia:</b>' + response.data.mensaje.encargo.ente.valor + '<br>' +
                      //     '<b>Cargo: </b>' + response.data.mensaje.encargo.empleo_cargo_comision + '<br>',
                      //   // +
                      //   // '¿Deseas solicitar la transferencia?',
                      //   buttonsStyling: false
                      // }).then(function () {

                      //   v.transferencia.ip_id = response.data.mensaje.id;
                      //   v.transferencia.ente_publico_origen = response.data.mensaje.encargo.ente_publico_id;
                      //   v.transferencia.ente_publico_destino = v.model.ente_publico_id;
                      //   v.transferencia.datos_cambio = v.model;

                      //   v.transferencia.datos_actuales = {
                      //     rfc: response.data.mensaje.rfc,
                      //     nombres: response.data.mensaje.nombres,
                      //     primer_apellido: response.data.mensaje.primer_apellido,
                      //     segundo_apellido: response.data.mensaje.segundo_apellido,
                      //     curp: response.data.mensaje.curp,
                      //     area_adscripcion: response.data.mensaje.encargo.area_adscripcion,
                      //     contratado_honorarios: response.data.mensaje.encargo.contratado_honorarios,
                      //     correo_laboral: response.data.mensaje.encargo.correo_laboral,
                      //     empleo_cargo_comision: response.data.mensaje.encargo.empleo_cargo_comision,
                      //     ente_publico_id: response.data.mensaje.encargo.ente_publico_id,
                      //     fecha_nacimiento: response.data.mensaje.fecha_nacimiento,
                      //     fecha_posesion: response.data.mensaje.encargo.fecha_posesion,
                      //     simplificada: response.data.mensaje.encargo.simplificada,
                      //     nivel_encargo: response.data.mensaje.encargo.nivel_encargo,
                      //     fecha_termino: response.data.mensaje.encargo.fecha_termino
                      //   }

                      //   v.transferencia.status = 0;

                      //   v.$http.post("solicitaT", v.transferencia).then(
                      //     response => {

                      //       if (response.data.solicitud.id === 'existe') {
                      //         swal({
                      //           title: 'Alerta',
                      //           text: 'Ya existe una solicitud de transferencia para esta persona, espera a que sea revisada.',
                      //           type: 'warning',
                      //           confirmButtonClass: 'btn btn-success btn-fill',
                      //           buttonsStyling: false
                      //         })
                      //       } else {
                      //         swal({
                      //           title: 'Solicitado',
                      //           text: 'La transferencia ha sido solicitada',
                      //           type: 'success',
                      //           confirmButtonClass: 'btn btn-success btn-fill',
                      //           buttonsStyling: false
                      //         })

                      //         v.limpiaCampos()
                      //       }

                      //     },
                      //     error => {
                      //       v.Err(error);
                      //     }
                      //   );


                      // }).catch(e => {
                      //   console.log("catch")
                      // })
                      // } else {
                      // this.StepW("Ya existe un registro con ese RFC o CURP en ésta dependencia")
                      // }
                    }
                  } else {
                    this.StepOk("Declarante Guardado")
                    this.limpiaCampos()
                  }
                },
                error => {
                  this.StepError(error);
                }
              ).catch(e => {
                console.log(e)
              });
            }
          }).catch(e => {
          reject(false)
        });
      },
      limpiaCampos() {
        this.$validator.pause();
        this.filter = '';
        this.pendientes = false;
        this.uTemp = {};
        this.model = {
          area_adscripcion: '',
          contratado_honorarios: '2',
          correo_laboral: '',
          curp: '',
          direccion_encargo_colonia: '',
          direccion_encargo_cp: '',
          direccion_encargo_entidad_federativa_id: '',
          direccion_encargo_localidad_id: '',
          direccion_encargo_municipio_id: '',
          direccion_encargo_numext: '',
          direccion_encargo_numint: '',
          direccion_encargo_pais_id: 150,
          direccion_vialidad_nombre: '',
          direccion_vialidad_tipo: '',
          empleo_cargo_comision: '',
          ente_publico_id: '',
          fecha_nacimiento: '',
          fecha_posesion: '',
          simplificada: '',
          nivel_encargo: '',
          nombres: '',
          primer_apellido: '',
          rfc: '',
          rfc_patron: '',
          segundo_apellido: '',
          telefono_laboral_extension: '',
          telefono_laboral_numero: '',
          periodo: null,
          tipo_dec: 1
        };
        this.n_domicilio = {
          pais_id: 150, // México
          entidadF: 11, // Estado Guanajuato
          municipio: '',
          localidad: '',
          cp: '',
          colonia: '',
          vialidad: '',
          vialidad_nombre: '',
          ext: '',
          int: ''
        };
      }

    },
    created() {
      this.getPeriodos();
      this.getKey('ente');
      this.checkPermissions();
      this.ip_id = this.getId();
      this.getEntes();
    },
    mounted() {
      this.checkCatalogs();
    },

  }

</script>
<style>
  .titulo {
    color: #737373 !important;
  }

  .swal2-modal .swal2-content {
    text-align: left !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/AltaPersonal.vue